import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=2bb58f6b&"
import script from "./Software.vue?vue&type=script&lang=js&"
export * from "./Software.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports